import type { RouteObject } from "react-router-dom";

export const assetsPath = "/assets";

export const assetsRoute: RouteObject = {
    path: assetsPath,
    lazy: async () => {
        const { AssetsPage } = await import("@/features/assets/page");
        return { Component: AssetsPage };
    },
};
